import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { LogService, MarketTrackingEvents } from "@rubbl-core";
import { HeaderService } from "@rubbl-layout";

@Component({
  selector: "app-home",
  templateUrl: "./home-layout.component.html",
  styleUrls: ["./home-layout.component.scss"],
})
export class HomeLayoutComponent implements OnInit {
  showLast: boolean;
  constructor(private headerService: HeaderService, private logService: LogService, private router: Router) {}

  ngOnInit() {
    this.headerService.showHomePageHeaderItems();
    this.logService.trackEvent(MarketTrackingEvents.Home.Visit);
  }

  ngAfterViewInit() {
    try {
      window["iFrameResize"]({ log: false, checkOrigin: false }, "#testimonialto-rubbl-homepage-tag-all-light");
    } catch (e) {}
  }

  goToListYourMachines() {
    this.router.navigate(["/lp/list-your-machines"]);
    this.logService.trackEvent(MarketTrackingEvents.Home.ListYourMachinesButtonClick);
  }
}
